module.exports = __webpack_public_path__ + "img/901712699.bb785bc2.png";